import { NumberField as NumberFieldPrimitive } from '@base-ui/react/number-field'
import { Minus, Plus } from 'lucide-react'
import * as React from 'react'

import { cn } from '../../lib/utils'

type NumberInputProps = React.ComponentProps<typeof NumberFieldPrimitive.Root> & {
  placeholder?: string
  withButtons?: boolean
}

function NumberInput({ className, placeholder, withButtons = false, ...props }: NumberInputProps) {
  return (
    <NumberFieldPrimitive.Root locale="fr-FR" className="w-full" {...props}>
      <NumberFieldPrimitive.Group
        className={cn(
          withButtons &&
            'border-input bg-background flex h-10 items-center rounded-lg border shadow-none overflow-hidden',
        )}
      >
        {withButtons && (
          <NumberFieldPrimitive.Decrement className="flex h-full items-center px-3 text-muted-foreground hover:text-foreground transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed border-r border-input">
            <Minus className="size-4" />
          </NumberFieldPrimitive.Decrement>
        )}

        <NumberFieldPrimitive.Input
          className={cn(
            'dark:bg-input/30 border-input focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 bg-background px-2.5 py-1 text-base shadow-none transition-[color,box-shadow] file:h-7 file:text-sm file:font-medium focus-visible:ring-[3px] aria-invalid:ring-[3px] md:text-sm file:text-foreground placeholder:text-muted-foreground w-full min-w-0 outline-none file:inline-flex file:border-0 file:bg-transparent disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
            withButtons
              ? 'h-full border-0 text-center focus-visible:ring-0 focus-visible:border-0'
              : 'h-9 rounded-lg border',
            className,
          )}
          placeholder={placeholder}
        />

        {withButtons && (
          <NumberFieldPrimitive.Increment className="flex h-full items-center px-3 text-muted-foreground hover:text-foreground transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed border-l border-input">
            <Plus className="size-4" />
          </NumberFieldPrimitive.Increment>
        )}
      </NumberFieldPrimitive.Group>
    </NumberFieldPrimitive.Root>
  )
}

export { NumberInput }
